import { Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import {MatDialog as MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.css']
})
export class PermissionsComponent implements OnInit {

  displayedColumns: string[] = ['id', 'name', 'actions'];
  @ViewChild(MatPaginator,{static:true}) paginator: MatPaginator;

  dataSource = new MatTableDataSource<any>([]);
  tempDataSource = new MatTableDataSource();
  dataLength: any;

  filterForm: any = { searchValue: '', categoriesIds: [], pageSize: 10, pageNo: 0, rolesSort: null };
  @ViewChild(MatSort,{static:true}) sort: MatSort;


  constructor(private httpClient: HttpClient,
     private snotifyService: ToastrService,
    public dialog: MatDialog,
    private router: Router) {
      
     }

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.sort = this.sort;
    this.getAll()
    const searchQuery = sessionStorage.getItem('rolesSearchQuery');
    if (searchQuery) {
      this.filterForm = JSON.parse(searchQuery);
      sessionStorage.removeItem('rolesSearchQuery');
      this.paginator.pageIndex = this.filterForm.pageNo
      this.paginator.pageSize = this.filterForm.pageSize
    }
  }

  getAll() {
    this.httpClient.get('/RolesManagement/GetRoles').subscribe((res: any) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataLength = res.length
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      // this.dataSource.filterPredicate =
      //   (data: any, filtersJson: string) => {
      //     const matchFilter = [];
      //     const filters = JSON.parse(filtersJson);

      //     filters.forEach(filter => {
      //       const val = data[filter.id] === null ? '' : data[filter.id];
      //       matchFilter.push(val.toLowerCase().includes(filter.value.toLowerCase()));
      //     });
      //     return matchFilter.every(Boolean);
      //   };
    });
  }

  public sortRoles(event) {
    this.filterForm.rolesSort = {
      SortField: event.active,
      SortType: event.direction ? event.direction : 'asc'
    }
    this.getAll() ;
  }

  AddRole() {
    this.router.navigate(['/users-permissions/add-role']);
  }

  edit(role) {

    this.router.navigate(['users-permissions/edit-role', role.id])
  }

  delete(role) {
    const data = {}
    this.httpClient.post('/RolesManagement/DeleteRole/' + role.id, data).subscribe((res) => {
      this.openNotifySuccess("Deleted Succefully");
      this.getAll()
    });


  }


  // applyFilter(filterValue: string) {
  //   const tableFilters = [];
  //   tableFilters.push({
  //     id: 'fullName',
  //     value: filterValue
  //   });

  //   this.dataSource.filter = JSON.stringify(tableFilters);
  //   if (this.dataSource.paginator) {
  //     this.dataSource.paginator.firstPage();
  //   }
  // }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

}

